/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
'use strict';
module.exports = ('capitalizeStringFilter', [ function () {
        return function (input) {
            
            return (!!input) ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : '';
        };
    }]);




//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-core/filters/capitalizeFilter.js
// module id = 319
// module chunks = 0